import { render, staticRenderFns } from "./emaillayout2.vue?vue&type=template&id=265871aa"
import script from "./emaillayout2.vue?vue&type=script&lang=js"
export * from "./emaillayout2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports